import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../lib/axios';
import { useNotification } from '../../../contexts/NotificationContext';
import { AuthContext } from '../../../contexts/AuthContext';
import { BACKGROUND_IMAGES } from '../constants/loginConstants';

export const useLogin = () => {
  const { showNotification } = useNotification();
  const { verifyAuth } = useContext(AuthContext);
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === BACKGROUND_IMAGES.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const validate = () => {
    const tempErrors = {};
    if (!username.trim()) {
      tempErrors.username = 'Username is required';
    } else if (username.trim().length < 3) {
      tempErrors.username = 'Username must be at least 3 characters long';
    }
    if (!password.trim()) {
      tempErrors.password = 'Password is required';
    } else if (password.trim().length < 6) {
      tempErrors.password = 'Password must be at least 6 characters long';
    }

    setErrors(tempErrors);
    if (Object.keys(tempErrors).length > 0) {
      showNotification('error', Object.values(tempErrors)[0]);
      return false;
    }
    return true;
  };

  const handleLogin = async (event) => {
    if (event) event.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      const response = await api.post('/signin', {
        identifier: username.trim(),
        password: password.trim()
      });

      const data = response.data;

      if (data.status === 'success') {
        showNotification('success', 'Login successful! Welcome back.');
        // Update the AuthContext state immediately
        await verifyAuth();
        setTimeout(() => {
          navigate('/home');
        }, 500);
      } else {
        throw new Error(data.message || 'Login failed. Check your credentials.');
      }
    } catch (err) {
      console.error('Login error:', err);
      showNotification('error', err.message || 'Unable to connect. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return {
    username, setUsername,
    password, setPassword,
    showPassword, setShowPassword,
    loading, currentImageIndex, setCurrentImageIndex,
    errors, 
    backgroundImages: BACKGROUND_IMAGES, 
    handleLogin
  };
};
